import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/core/services/customer.service';

import * as moment from 'moment';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-clients-invoice',
  templateUrl: './clients-invoices.component.html',
  styleUrls: ['./clients-invoices.component.css'],
})
export class ClientsInvoicesComponent implements OnInit {
  @Input() customer: any;
  @Output() formBody = new EventEmitter<Object>();
  @ViewChild('dialogClientsInvoices')
  public dialogClientsInvoices: TemplateRef<any>;

  customInvoiceConfigEnable: boolean = false;
  customInvoiceConfigComboEnable: boolean = true;
  defaultInvoiceType: string = 'combo';
  toggleCsvInfo: boolean = false;
  invoiceCount: number = 100;
  clientsInvoices: any;
  csvStillWaiting: boolean = false;

  toggleDateError = false;
  fromDateSearch = '';
  toDateSearch = '';
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  fromDateCount: NgbDate | null;
  toDateCount: NgbDate | null;
  hoveredDate: NgbDate | null = null;

  private modalClientsInvoices: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {}

  open(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalClientsInvoices = this.modalService.open(
        this.dialogClientsInvoices
      );
      this.modalClientsInvoices.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    this.modalClientsInvoices.close();
  }

  isGenerating = false;
  generateCSV() {
    if (!this.areDatesValid()) {
      return;
    }

    if (this.fromDateSearch && this.toDateSearch) {
      this.customerService
        .generateClientsCSV(
          this.customer.id,
          this.fromDateSearch,
          this.toDateSearch,
          this.customInvoiceConfigEnable,
          this.customInvoiceConfigComboEnable
        )
        .pipe(switchMap(() => this.getAllClientsInvoices()))
        .subscribe(
          (res) => {
            this.invoiceCount = res.count;
            this.clientsInvoices = res.results;
            this.toggleCsvInfo = true;
            this.isGenerating = true;
          },
          (err) => {
            this.toastr.error(err.message);
            this.isGenerating = false;
          }
        );
    } else {
      this.translate.get('errors.chooseDate').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
  }

  onLoadInvoices() {
    this.getAllClientsInvoices().subscribe(
      (res) => {
        this.clientsInvoices = res.results;
        res.results.some((invoice) => {
          if (invoice.csvStatus !== 'completed') {
            this.csvStillWaiting = true;
            this.toggleCsvInfo = true;
            this.isGenerating = true;
          } else {
            this.csvStillWaiting = false;
            this.toggleCsvInfo = false;
            this.isGenerating = false;
          }
        });
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  getAllClientsInvoices() {
    return this.customerService.getClientsInvoices(
      this.customer.id,
      1,
      this.invoiceCount,
      this.fromDateSearch,
      this.toDateSearch
    );
  }

  invoiceConfig($event) {
    switch ($event.target.value) {
      case 'custom':
        this.customInvoiceConfigEnable = true;
        this.customInvoiceConfigComboEnable = false;
        break;
      case 'default':
        this.customInvoiceConfigEnable = false;
        this.customInvoiceConfigComboEnable = false;
        break;
      case 'combo':
        this.customInvoiceConfigEnable = false;
        this.customInvoiceConfigComboEnable = true;
        break;
    }
  }

  areDatesValid(): boolean {
    const from = (document.getElementById('fromDate') as HTMLInputElement)
      .value;
    let d = '';

    if (from !== '') {
      let fromDate = moment(
        from,
        ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD'],
        true
      );
      if (!fromDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      this.fromDateSearch = new Date(
        fromDate.format('YYYY-MM-DD')
      ).toISOString();
    } else {
      this.fromDateSearch = undefined;
      this.fromDate = null;
    }

    const to = (document.getElementById('toDate') as HTMLInputElement).value;
    let t = '';
    if (to !== '') {
      let toDate = moment(to, ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD'], true);
      if (!toDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      t = new Date(toDate.format('YYYY-MM-DD')).toISOString();
      console.log(t);
      this.toDateSearch = t.substring(0, t.indexOf('T') + 1) + '23:59:59.000Z';
    } else {
      this.toDateSearch = undefined;
      this.toDate = null;
    }
    return true;
  }

  onDateSelection(date: NgbDate, datepicker: any) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate) {
      this.toDate = date;
      datepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.isGenerating = false;
    this.csvStillWaiting = false;
    this.toggleCsvInfo = false;
    this.clientsInvoices = null;
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  lastWeek() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
    this.toDate = this.calendar.getToday();
  }

  lastMonth() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'm', 1);
    this.toDate = this.calendar.getToday();
  }

  getInvoiceFile(url: string) {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    const res = this.http
      .get(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }

  // Convert date to "01-04-24" format
  formatDate(date: NgbDate) {
    const myMoment: moment.Moment = moment(date);

    // NgbDates use 1 for Jan, Moement uses 0, must substract 1 month for proper date conversion
    var convertedMoment = myMoment.subtract(1, 'months');

    if (convertedMoment.isValid()) {
      return convertedMoment.format('DD-MM-YY');
    } else {
      return '';
    }
  }

  downloadFiles() {
    let to = this.formatDate(this.toDate);
    let from = this.formatDate(this.fromDate);
    const zip = new JSZip();
    this.clientsInvoices.forEach((invoice) => {
      if (this.customInvoiceConfigEnable) {
        if (
          invoice.client.customInvoiceConfig !== null &&
          invoice.client.customInvoiceConfig.columns.length
        ) {
          zip.file(
            `${invoice.client.name}_${invoice.number}.csv`,
            this.getInvoiceFile(invoice.csvLink)
          );
        }
      } else {
          zip.file(
            `${invoice.client.name}_${invoice.number}.csv`,
            this.getInvoiceFile(invoice.csvLink)
          );
      }
    });
    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `Clients-Invoices_${from}_${to}.zip`);
    });
  }
}